<template>
  <div class="row">
    <div>
      <div id="ItemDetails">
        <template v-for="(item, index) in set.items">
          <div class="row" v-bind:key="'item' + index">
            <div class="col-7">
              <h5>
                {{ $t("Set.Overview.item.details") }}:
                <template v-if="item.name !== ''">
                  {{ item.name }}
                </template>
                <template v-else>
                  {{ $t("Set.Overview.item.title") }} {{ index + 1 }}
                </template>
              </h5>
            </div>
            <div class="col-5 text-end">
              <img
                @click="dropItem(index)"
                :src="appUrl + '/img/icons/drop.svg'"
                class="icon"
                :alt="$t('Set.Overview.item.button.delete')"
              />
              <img
                @click="switchCurrentItem(index)"
                :src="appUrl + '/img/icons/edit.svg'"
                class="icon"
                :alt="$t('Set.Overview.item.button.edit')"
              />
            </div>
          </div>
          <div class="row" v-bind:key="index">
            <div class="col-12">
              <hr />
            </div>
          </div>
          <div class="row" v-bind:key="'item-desc-' + index">
            <div
              :class="{
                'col-12 table-col': item.description.jewelleryType != 5,
                'col-12': item.description.jewelleryType == 5,
              }"
            >
              <table class="table table-responsive table-striped">
                <tr>
                  <td>{{ $t("Set.Overview.item.itemnumber") }}:</td>
                  <td>
                    {{ item.itemnumber }}
                    <CopyIcon
                      :textToCopy="item.itemnumber"
                      iconWidth="2"
                      feedback="icon"
                    />
                  </td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.ringsize &&
                    item.description.jewelleryType != 5
                  "
                >
                  <td>{{ $t("Set.Item.Description.ringsize") }}</td>
                  <td>{{ item.size }}</td>
                </tr>
                <tr
                  v-else-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.chainWidths
                  "
                >
                  <td>{{ $t("Set.Item.Description.width") }}</td>
                  <td>{{ item.description.width }} mm</td>
                </tr>
                <tr
                  v-if="
                    item.description.jewelleryType != 5 &&
                    item.description.possibleVariations &&
                    item.description.possibleVariations.engraving
                  "
                >
                  <td>{{ $t("Set.Item.Description.engraving.title") }}:</td>
                  <td>
                    <p v-if="item.engraving.inside.font > 0">
                      <span v-if="item.engraving.inside.text != ''"
                        >{{ item.engraving.inside.text }}<br
                      /></span>
                      {{ $t("Set.Item.Description.engraving.inside") }}:
                      {{ getEngravingText(item.engraving.inside.font) }}
                      <br />
                    </p>
                    <p v-if="item.engraving.outside.font > 0">
                      <span v-if="item.engraving.outside.text != ''"
                        >{{ item.engraving.outside.text }}<br
                      /></span>
                      {{ $t("Set.Item.Description.engraving.outside") }}:
                      {{ getEngravingText(item.engraving.outside.font) }}
                      <br />
                    </p>
                    <p
                      v-if="
                        item.engraving.inside.text == '' &&
                        item.engraving.outside.text == ''
                      "
                    >
                      {{ $t("Set.Item.Description.engraving.noEngraving") }}
                    </p>
                  </td>
                </tr>
                <tr v-if="item.description.jewelleryType < 1">
                  <td>
                    {{ $t("Set.Item.Description.width") }} /
                    {{ $t("Set.Item.Description.height") }}
                  </td>
                  <td>
                    {{ item.description.width }} mm /
                    {{ item.description.height }} mm
                  </td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.lengths
                  "
                >
                  <td>{{ $t("Set.Item.Description.length") }}</td>
                  <td>{{ item.description.length }} cm</td>
                </tr>
                <tr v-if="item.description.jewelleryType < 1">
                  <td>{{ $t("Set.Item.Description.profile") }}</td>
                  <td>{{ item.description.profile }}</td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.shutters
                  "
                >
                  <td>{{ $t("Set.Item.Description.shutter") }}</td>
                  <td>{{ item.description.profile }}</td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.allocations
                  "
                >
                  <td>{{ $t("Set.Item.Description.allocations") }}</td>
                  <td>
                    {{
                      $tc(
                        "Common.itemAllocation." + item.description.ringType,
                        item.description.numberOfDiscs
                      )
                    }}
                  </td>
                </tr>
                <tr v-if="item.description.jewelleryType != 5">
                  <td>{{ $t("Set.Overview.item.color") }}:</td>
                  <td>{{ item.description.metal }}</td>
                </tr>
                <tr v-if="item.description.jewelleryType < 1">
                  <td>{{ $t("Set.Item.Description.finish") }}:</td>
                  <td>{{ item.description.finish }}</td>
                </tr>
                <tr
                  v-if="
                    ((item.description.possibleVariations &&
                      item.description.possibleVariations.grooves) ||
                      (item.description.grooves != '' &&
                        item.description.grooves != '-')) &&
                    item.description.jewelleryType != 5
                  "
                >
                  <td>{{ $t("Set.Item.Description.grooves.title") }}:</td>
                  <td>
                    <p
                      v-if="
                        item.description.grooves != '' &&
                        item.description.grooves != '-'
                      "
                    >
                      {{ item.description.grooves }}
                    </p>
                    <p v-else>{{ $t("Set.Item.Description.grooves.empty") }}</p>
                  </td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.addons
                  "
                >
                  <td>{{ $t("Set.Item.Description.addons.title") }}</td>
                  <td>
                    <p v-if="item.description.addons != ''">
                      {{ item.description.addons }}
                    </p>
                    <p v-else>{{ $t("Set.Item.Description.addons.empty") }}</p>
                  </td>
                </tr>
                <tr
                  v-if="
                    item.description.possibleVariations &&
                    item.description.possibleVariations.jewellery &&
                    item.description.possibleVariations.jewellery.necklace
                  "
                >
                  <td>{{ $t("Set.Item.Description.necklace") }}</td>
                  <td>{{ item.description.model }}</td>
                </tr>
                <tr
                  v-if="
                    item.description.stones &&
                    item.description.stones.text != '' &&
                    item.description.jewelleryType != 5
                  "
                >
                  <td>{{ $t("Set.Overview.item.stones") }}:</td>
                  <td>
                    <span v-html="item.description.stones.text"></span>
                    <div class="stone-addons" v-if="isStoneAddon(index)">
                      <span class="stone-addons-title"
                        >{{ $t("Menu.list.stones.group.addon.title") }}:</span
                      >
                      <ul
                        style="list-style: none; padding: 0"
                        v-for="(group, index) in item.description.stones.groups"
                        v-bind:key="'group_addon_' + index"
                      >
                        <li
                          v-for="(addon, key) in group.addons"
                          v-bind:key="'addon_' + key"
                        >
                          {{ setAddonText(addon.text) }}
                        </li>
                      </ul>
                    </div>
                    <div
                      class="stone-setting"
                      v-if="
                        item.description.stones.text !== '' &&
                        item.description.stones.groups[0]['setting'] !== ''
                      "
                    >
                      <span class="stone-setting-title"
                        >{{ $t("Menu.var.jewellery.setting") }}:</span
                      >
                      <ul style="list-style: none; padding: 0">
                        <li
                          v-for="(group, index) in item.description.stones
                            .groups"
                          v-bind:key="'group_setting_' + index"
                        >
                          {{ setStoneSettingText(group["setting"]) }}
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
                <tr
                  v-if="
                    item.description.stones &&
                    item.description.stones.diamondStock != false
                  "
                >
                  <td>
                    {{ $t("Menu.list.diamondStock.selectedStone.title") }}
                  </td>
                  <td>
                    {{ item.description.stones.diamondStock.description }}
                  </td>
                </tr>
                <tr v-if="item.description.jewelleryType != 5">
                  <td>{{ $t("Set.Overview.item.brand") }}:</td>
                  <td>
                    {{ item.description.brand }}
                    <span
                      v-if="
                        isShopLoginActive &&
                        $parent['isDiamondGroupPline'](
                          parseInt(item.description['plineId'])
                        )
                      "
                    >
                      (DiamondGroup)
                    </span>
                  </td>
                </tr>
                <tr v-if="item.description.jewelleryType == 5">
                  <td style="padding-top: 2rem">
                    <strong>{{ $t("Set.Overview.item.price.total") }}:</strong>
                  </td>
                  <td class="text-end" style="padding-top: 2rem">
                    <strong>{{ $n(item.price.total, "currency") }}</strong>
                  </td>
                </tr>
              </table>
            </div>
            <div
              class="col-12 table-col"
              v-if="
                typeof item.description.jewelleryType != 'undefined' &&
                item.description.jewelleryType != 5
              "
            >
              <h5 class="title-price">
                {{ $t("Set.Item.Description.price.title") }}
              </h5>
              <table class="table table-responsive table-striped table-price">
                <tr>
                  <td>
                    {{
                      $t(
                        "Common.jewelleryType." + item.description.jewelleryType
                      )
                    }}:
                  </td>
                  <td>
                    <span
                      v-if="
                        (!item.price.discount || item.price.discount == 0) &&
                        !$parent['isDiamondGroupPline'](
                          parseInt(item.description['plineId'])
                        )
                      "
                    >
                      {{ $n(item.price.ring, "currency") }}
                    </span>
                    <span v-else-if="item.price.discount && item.price.discount > 0">
                      {{ $n(item.price.totalOriginal - item.price.discount, "currency") }}
                    </span>
                    <span v-else>{{
                      $n(item.price.ring + item.price.stone, "currency")
                    }}</span>
                  </td>
                </tr>
                <tr
                  v-if="
                    (!item.price.discount || item.price.discount == 0) &&
                    item.price.stone > 0 &&
                    !$parent['isDiamondGroupPline'](
                      parseInt(item.description['plineId'])
                    )
                  "
                >
                  <td>{{ $t("Set.Overview.item.price.stone") }}:</td>
                  <td>
                    <span>{{ $n(item.price.stone, "currency") }}</span>
                  </td>
                </tr>
                <tr>
                  <td>{{ $t("Set.Overview.item.price.engraving") }}:</td>
                  <td>
                    <span>{{ $n(item.price.engraving, "currency") }}</span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong
                      v-if="!item.price.discount || item.price.discount == 0"
                      >{{ $t("Set.Overview.item.price.total") }}:</strong
                    >
                    <strong v-else class="price-discount"
                      >{{ $t("Set.Overview.item.price.special") }}:</strong
                    >
                  </td>
                  <td>
                    <strong
                      :class="
                        item.price.discount && item.price.discount > 0
                          ? 'price-discount'
                          : ''
                      "
                    >
                      {{
                        $n(item.price.total + item.price.engraving, "currency")
                      }}
                    </strong>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </template>
      </div>
      <div class="col-12 total-price">
        <h5 v-if="set.totalDiscount == 0">
          {{ $t("Set.Overview.totalPrice") }}:
        </h5>
        <h5 v-else>{{ $t("Set.Overview.specialPrice") }}:</h5>
        <p class="price">
          <span v-if="set.totalDiscount == 0">{{
            $n(set.totalPrice, "currency")
          }}</span>
          <template v-else>
            <span class="price-discount">{{
              $n(set.totalPrice, "currency")
            }}</span>
          </template>
        </p>
        <div class="row">
          <div class="col-12 col-sm-4 btn-col">
            <a
              @click="closeSummary"
              class="btn btn-secondary btn-block btn-action"
            >
              {{ $t("Common.itemDetailsHideShort") }}
            </a>
          </div>
          <div class="col-12 col-sm-4 btn-col">
            <a class="btn btn-secondary btn-block btn-action" @click="printUrl">
              <label>{{ $t("Set.Social.print") }}</label>
            </a>
          </div>
          <div class="col-12 col-sm-4 btn-col">
            <a
              class="btn btn-primary btn-block btn-action"
              @click="addToShoppingCart"
            >
              {{ $t("Set.Overview.button.shopOrder") }}
            </a>
          </div>
        </div>
      </div>
      <div
        class="col-12 campaign-info text-center"
        v-if="isCampaignWeddingRings"
      >
        <p>{{ $t("Set.Overview.campaign.discount") }}</p>
      </div>
    </div>
    <!--
   <div
     class="row campaign-disclaimer text-center"
     v-if="isCampaignWeddingRings && !isDesktop"
   >
     <div class="col-12">
       <small>* {{ $t("Set.Overview.campaign.disclaimer") }}</small>
     </div>
   </div>
   -->
 </div>
</template>

<script>
import Config from "@/vuex/Config";
import SetData from "@/vuex/SetData";
import Engraving from "@/vuex/Engraving";
import ShoppingCart from "@/assets/ShoppingCart";
import CopyIcon from "./Icons/Copy";
import MediaQuery from "@/assets/Helper/MediaQuery";

export default {
 name: "ItemDetails",
 components: {
   CopyIcon,
 },
 data() {
   return {
     config: Config.getters.getConfig,
     appUrl: Config.getters.getAppUrl,
     campaigns:
       typeof window.conf2020AppConfig.campaigns === "object"
         ? window.conf2020AppConfig.campaigns
         : { weddingbands: "no", jewellery: "no", priceDrop: "no" },
     set: SetData.getters.getSet,
     stoneSettingText: {},
     addonText: {},
   };
 },
 methods: {
   closeSummary: function () {
     this.$parent["showItemDetails"] = false;
     this.$root.$emit("setOverview");
   },
   printUrl: function () {
     if (
       typeof window.conf2020AppConfig.printOutUrl === "string" &&
       window.conf2020AppConfig.printOutUrl !== ""
     ) {
       window.open(
         window.conf2020AppConfig.printOutUrl.replace(
           "<itemnumber>",
           SetData.getters.getItemStr
         ),
         "_blank"
       );
     }
   },
   isStoneAddon: function (currentItem) {
     for (let i in this.set.items[currentItem].description.stones.groups) {
       if (
         this.set.items[currentItem].description.stones.groups[i].addons &&
         this.set.items[currentItem].description.stones.groups[i].addons[0]
       ) {
         return true;
       }
     }
     return false;
   },
   setAddonText: function (addonText) {
     addonText = addonText.toString().trim();
     if (!this.addonText[addonText]) {
       this.addonText[addonText] = true;
     } else {
       addonText = "";
     }
     return addonText;
   },
   setStoneSettingText: function (stoneSettingText) {
     stoneSettingText = stoneSettingText.trim();
     if (!this.stoneSettingText[stoneSettingText]) {
       this.stoneSettingText[stoneSettingText] = true;
     } else {
       stoneSettingText = "";
     }
     return stoneSettingText;
   },
   getEngravingText: function (fontId) {
     return Engraving.getters.getFontTextById(fontId);
   },
   addToShoppingCart: function () {
     ShoppingCart.add();
   },
   dropItem: function (itemKey) {
     this.$parent["showItemDetails"] = false;

     Config.dispatch("setVisualMode", "show").then(() => {
       Config.dispatch("setCurrentVarType", "");

       this.$root.$emit("setOverview");
     });

     SetData.dispatch("dropItem", itemKey);

     this.$parent.$parent["reset3d"](true);
     this.$parent.$parent["setCurrentItem"]("overview");
   },
   switchCurrentItem: function (newCurrentItem) {
     this.$parent["showItemDetails"] = false;

     this.$parent.$parent["setCurrentItem"](newCurrentItem);
     this.$root.$emit("setOverview");

     Config.dispatch("setVisualMode", "show").then(() => {
       Config.dispatch("setCurrentVarType", "").then(() =>
         this.$root.$emit("hideLoader3D")
       );
     });

     if (!MediaQuery.isDesktop()) {
       document.querySelector(".image-col-right").scrollIntoView();
     }
   },
 },
 computed: {
   isShopLoginActive: function () {
     return Config.getters.isShopLoginActive;
   },
   isCampaignWeddingRings: function () {
     return (
       this.campaigns.weddingbands === "yes" && this.$parent.onlyWeddingRings()
     );
   },
   isCampaignPriceDrop: function () {
     return (
       this.campaigns.priceDrop === "yes" && !this.$parent.onlyJewellery()
     );
   },
   isDesktop: function () {
     return MediaQuery.isDesktop();
   },
 },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
#app {
  .total-price {
    line-height: 5rem;
    text-align: center;
    padding-left: 0rem;
    padding-right: 0rem;
    margin-bottom: 2rem;
    background-color: $white;

    h5,
    p {
      text-align: center;
    }

    h5 {
      padding: 1.5rem 0;
    }

    p {
      padding: 0 0.5rem 0.5rem 0;
      font-size: 2.5em;
    }

    @media (min-width: 992px) {
      padding-left: 1.5rem;
      padding-right: 1.5rem;
    }
  }

  .price-discount {
    color: $pink;
  }

  .price-original {
    text-decoration: line-through;
    color: #b5b5b5;
  }

  .campaign-info {
    color: $pink;
    font-weight: bold;
    margin-top: -1rem;
    margin-bottom: 2rem;
  }

  .campaign-disclaimer {
    small {
      display: inline-block;
      margin-top: 2rem;
    }
  }

  #ItemDetails {
    background-color: $white;
    margin-bottom: 1.5rem;

    padding-top: 1rem;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .table > :not(caption) > * > * {
      padding: 0;
    }

    h5 {
      margin-top: 1.5rem;
    }

    h5.title-price {
      font-size: 1.6rem;
      margin-bottom: 0.5rem;
    }

    .icon {
      margin: 1rem;
    }

    table {
      border: none;

      &.table-price {
        border-top: 1px solid #444444;

        tr {
          td:last-child {
            text-align: right;
          }
        }
      }

      tr {
        td:first-child {
          width: 40%;
        }

        td {
          vertical-align: top;
          padding: 0.5rem 0;
          margin: 0;

          strong {
            padding: 0 0.5rem 0 0;
          }

          p:last-child {
            margin: 0;
          }
        }
      }
    }

    ul {
      list-style: none;
      padding-left: 0;
      margin: 0;

      li {
        margin-bottom: 0.5rem;
      }
    }

    div.stone-addons,
    div.stone-setting {
      margin-top: 2rem;
    }
  }

  .btn-action {
    margin-bottom: 1rem;
    width: 100%;
  }

  p.price {
    margin-bottom: 4rem;
  }

  .text-end {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
